import { baseURL } from './http.js';
import request from './request.js';

export default {
  pdLibraryListPage: (param) => request(baseURL).post('pdLibrary/listPage', param),
  pdLibraryListPageMall: (param) => request(baseURL).post('pdLibrary/listPageMall', param),
  pdLibraryDelete: (param) => request(baseURL).post('pdLibrary/delete', param),
  pdLibraryBatchSubmit: (param) => request(baseURL).post('pdLibrary/batchSubmit', param),
  pdLibraryBatchRecall: (param) => request(baseURL).post('pdLibrary/batchRecall', param),
  pdLibraryBatchPutOn: (param) => request(baseURL).post('pdLibrary/batchPutOn', param),
  pdLibraryBatchTakeOff: (param) => request(baseURL).post('pdLibrary/batchTakeOff', param),
  pdLibraryAudit: (param) => request(baseURL).post('pdLibrary/audit', param),
  pdLibraryListPageAudit: (param) => request(baseURL).post('pdLibrary/listPageAuditRecord', param),
  listByFirstCategory: (val) => request(baseURL).get(`pdCategory/listByFirstCategory?firstCategory=${val}`),
  getPdImportTemplateUrl: () => request(baseURL).get('pdLibrary/getPdImportTemplateUrl'),
  pdLibraryImportDatas: (param) => request(baseURL).post('pdLibrary/importDatas', param),
  
  pdMroFacilityCreate: (param) => request(baseURL).post('pdMroFacility/create', param),
  pdMroFacilityUpdate: (param) => request(baseURL).post('pdMroFacility/update', param),
  pdMroFacilityGet: (id) => request(baseURL).get(`pdMroFacility/get?id=${id}`),

  pdEpAndAdministrationCreate: (param) => request(baseURL).post('pdEpAndAdministration/create', param),
  pdEpAndAdministrationUpdate: (param) => request(baseURL).post('pdEpAndAdministration/update', param),
  pdEpAndAdministrationGet: (id) => request(baseURL).get(`pdEpAndAdministration/get?id=${id}`),

  pdItCreate: (param) => request(baseURL).post('pdIt/create', param),
  pdItUpdate: (param) => request(baseURL).post('pdIt/update', param),
  pdItGet: (id) => request(baseURL).get(`pdIt/get?id=${id}`),

  pdMaterialCreate: (param) => request(baseURL).post('pdMaterial/create', param),
  pdMaterialUpdate: (param) => request(baseURL).post('pdMaterial/update', param),
  pdMaterialGet: (id) => request(baseURL).get(`pdMaterial/get?id=${id}`),
  
  pdOfflineCreate: (param) => request(baseURL).post('pdOffline/create', param),
  pdOfflineUpdate: (param) => request(baseURL).post('pdOffline/update', param),
  pdOfflineGet: (id) => request(baseURL).get(`pdOffline/get?id=${id}`),

  pdProfessionalServiceCreate: (param) => request(baseURL).post('pdProfessionalService/create', param),
  pdProfessionalServiceUpdate: (param) => request(baseURL).post('pdProfessionalService/update', param),
  pdProfessionalServiceGet: (id) => request(baseURL).get(`pdProfessionalService/get?id=${id}`),

  pdAuditConfigListAll: (param) => request(baseURL).post('pdAuditConfig/listAll', param),
  pdAuditConfigDelete: (param) => request(baseURL).post(`pdAuditConfig/delete?id=${param.id}` ),
  pdAuditConfigCreate: (param) => request(baseURL).post('pdAuditConfig/create', param),
  pdAuditConfigUpdate: (param) => request(baseURL).post('pdAuditConfig/update', param),
  getCurrentUserConfig: () => request(baseURL).get('pdAuditConfig/getCurrentUserConfig')
};